module.exports = __webpack_public_path__ + "static/media/spices_Thumb_1.f18f7d2d.jpg";